import { styled } from "@mui/material/styles";
import clsx from "clsx";
import {
  isFlownSegment,
  segmentClass,
  segmentFlightDateTime,
} from "../../../utils";
import RowDetailField from "../../RowDetailField";

const ItinerarySegmentDetails = (props) => {
  const { isEmd, segment } = props;
  return (
    <RowDetailField
      label={
        <span>
          <span>{props.order}. </span>
          <span
            className={clsx(props.className, {
              Flown: !isEmd && isFlownSegment(segment),
              IsRefund: props.isRefund,
            })}
          >
            {`${segment?.o} - ${segment?.d}`}
          </span>
        </span>
      }
      value={
        isEmd
          ? segment?.descr || ""
          : `${segmentClass(segment)}${segmentFlightDateTime(segment)}`
      }
    />
  );
};

export default styled(ItinerarySegmentDetails)(
  ({ theme }) => `
  &.Flown {
    border-bottom: 3px solid #90ee90;
  }

  &.Flown.IsRefund {
    border: 0px;
  }
`,
);
